module.exports = __webpack_public_path__ + "static/media/feedback.e5038936.png";